import React, { ElementType, Suspense } from 'react';

// project import
import SubscriptionLoaderWrapper from './SubscriptionLoaderWrapper';

// ==============================|| LOADABLE - LAZY LOADING ||============================== //

const Loadable = (Component: ElementType) =>
  function LoadableComponent() {
    return (
      <Suspense fallback={<SubscriptionLoaderWrapper />}>
        <Component />
      </Suspense>
    );
  };

export default Loadable;
